import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { Session } from 'app/shared/services/session/session.service';
import { CONFIG } from 'app/config/config';

declare var unescape: any;

@Injectable()
export class ImageUploadService {
  constructor(private _http: Http, private _session: Session) { }

  getAllAWSImagesByApp(sysName: string) {
    return this._http.get(CONFIG.ENDPOINT_URL + 'apps/' + sysName + '/aws/library', { headers: this._session.headers() })
      .toPromise()
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.log(e);
      });
  }

  getPresignedAwsUploadRequest(sysName: string, original?: boolean, extension?: string, originalName?: string) {
    if (!original) original = false;
    let queryString = '?is_original=' + original;
    if (extension) queryString += '&type=' + extension;
    if (originalName) queryString += '&original_key=' + originalName;
    return this._http.get(CONFIG.ENDPOINT_URL + 'apps/' + sysName + '/aws' + queryString,
      { headers: this._session.headers() })
      .toPromise()
      .catch(err => {
        throw new Error(err);
      });
  }

  postFileToAws(awsPostBody: any, file: any): Promise<any> {
    awsPostBody.fields.file = file;
    let body = this.jsonToFormData(awsPostBody.fields);
    return this._http.post(awsPostBody.url, body)
      .toPromise()
      .catch(err => {
        throw new Error(err);
      });
  }

  uploadCroppedImage(sys_name: string, image: string, originalName?: string) {
    return this.upload(sys_name, this.getImageAsBlob(image), false, null, originalName);
  }

  uploadOriginalImage(sys_name: string, image: File) {
    let extension = image.name.split('.').pop();
    return this.upload(sys_name, image, true, extension);
  }

  upload(sys_name: string, image: any, original: boolean = false, extension?: string, originalName?: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getPresignedAwsUploadRequest(sys_name, original, extension, originalName)
        .then((data) => {
          data = data.json();
          return this.postFileToAws(data, image)
            .then((response) => {
              if (this.getXmlPropertyValue('Location', response._body) === null) {
                reject('Image upload failed');
                return;
              }
              resolve(this.getXmlPropertyValue('Location', response._body));
            })
            .catch(err => {
              reject('Image upload failed');
            });
        })
        .catch(err => {
          reject('Image upload failed');
        });
    });
  }

  getXmlPropertyValue(property: string, data: string) {
    let container = document.createElement('div');
    container.innerHTML = data;
    return container.getElementsByTagName(property)[0].innerHTML;
  }

  jsonToFormData(jsonObj: any): FormData {
    let formData: FormData = new FormData();
    for (var key in jsonObj) {
      formData.append(key, jsonObj[key]);
    }
    return formData;
  }

  getImageAsBlob(image: string) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    let byteString;
    if (image.split(',')[0].indexOf('base64') >= 0) byteString = atob(image.split(',')[1]);
    else byteString = unescape(image.split(',')[1]);

    // separate out the mime component
    let mimeString = image.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    let ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/image-upload/image-upload.service.ts